import script from "./HeroHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroHeader.vue?vue&type=script&setup=true&lang=ts"

import "./HeroHeader.vue?vue&type=style&index=0&id=169c08e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-169c08e0"]])

export default __exports__